var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon43(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3",
    "data-name": "Calque 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.2,118.8h0v84.4H103.1C121.8,175,140.6,143.8,156.2,118.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.5,0H62.5A62.65,62.65,0,0,0,0,62.5v250A62.65,62.65,0,0,0,62.5,375h375A62.65,62.65,0,0,0,500,312.5V62.5C500,25,471.8,0,437.5,0ZM184.3,259.4H156.2V228.2H75v-25c21.9-37.5,43.8-75,65.6-109.4h40.6V203.2h21.9v25H181.2l3.1,31.2Zm50,34.4h-25L268.7,84.4h25Zm121.9-31.3c-34.4,0-59.4-18.8-62.5-50h28.1c0,15.6,15.6,25,34.4,25s31.2-9.4,31.2-25-12.5-25-31.2-25H334.3V165.6h18.8c15.6,0,28.1-9.4,28.1-25,0-12.5-9.4-25-28.1-25s-28.1,9.4-31.2,25H293.8c0-28.1,25-50,59.4-50s56.2,18.8,53.1,43.7c0,18.8-12.5,31.2-31.2,37.5v3.1c21.9,3.1,37.5,18.8,37.5,40.6C415.6,243.8,390.6,262.5,356.2,262.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon43);
export default __webpack_public_path__ + "static/media/icon-4-3.2a05aa4fa51f271ce4e7c61e8e0dc3fe.svg";
export { ForwardRef as ReactComponent };